"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "player_name" };
const _hoisted_2 = { class: "other_player_cont menu" };
const _hoisted_3 = {
    key: 0,
    class: "player_home_block"
};
const _hoisted_4 = {
    key: 1,
    class: "player_home_block"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    const _component_Card = (0, vue_1.resolveComponent)("Card");
    const _component_stacked_cards = (0, vue_1.resolveComponent)("stacked-cards");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", null, [
        (0, vue_1.createElementVNode)("div", {
            class: (0, vue_1.normalizeClass)(['player_translucent_bg_color_' + _ctx.player.color, "other_player_header"])
        }, [
            (0, vue_1.createElementVNode)("div", _hoisted_1, [
                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.player.name) + " ", 1),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[0] || (_cache[0] = [
                        (0, vue_1.createTextVNode)("played cards", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createVNode)(_component_AppButton, {
                size: "big",
                type: "close",
                onClick: _ctx.hideMe,
                disableOnServerBusy: false,
                align: "right"
            }, null, 8, ["onClick"])
        ], 2),
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (_ctx.player.tableau.length > 0)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3, [
                    (0, vue_1.createElementVNode)("div", null, [
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getCardsByType(_ctx.player.tableau, [_ctx.CardType.CORPORATION]), (card) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                key: card.name,
                                class: "cardbox"
                            }, [
                                (0, vue_1.createVNode)(_component_Card, {
                                    card: card,
                                    actionUsed: _ctx.isCardActivated(card, _ctx.player),
                                    cubeColor: _ctx.player.color
                                }, null, 8, ["card", "actionUsed", "cubeColor"])
                            ]));
                        }), 128)),
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getCardsByType(_ctx.player.tableau, [_ctx.CardType.CEO]), (card) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                key: card.name,
                                class: "cardbox"
                            }, [
                                (0, vue_1.createVNode)(_component_Card, {
                                    card: card,
                                    actionUsed: _ctx.isCardActivated(card, _ctx.player),
                                    cubeColor: _ctx.player.color
                                }, null, 8, ["card", "actionUsed", "cubeColor"])
                            ]));
                        }), 128)),
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.sortActiveCards(_ctx.getCardsByType(_ctx.player.tableau, [_ctx.CardType.ACTIVE])), (card) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                key: card.name,
                                class: "cardbox"
                            }, [
                                (0, vue_1.createVNode)(_component_Card, {
                                    card: card,
                                    actionUsed: _ctx.isCardActivated(card, _ctx.player),
                                    cubeColor: _ctx.player.color
                                }, null, 8, ["card", "actionUsed", "cubeColor"])
                            ]));
                        }), 128)),
                        (0, vue_1.createVNode)(_component_stacked_cards, {
                            cards: _ctx.getCardsByType(_ctx.player.tableau, [_ctx.CardType.AUTOMATED, _ctx.CardType.PRELUDE]),
                            player: _ctx.player
                        }, null, 8, ["cards", "player"]),
                        (0, vue_1.createVNode)(_component_stacked_cards, {
                            cards: _ctx.getCardsByType(_ctx.player.tableau, [_ctx.CardType.EVENT]),
                            player: _ctx.player
                        }, null, 8, ["cards", "player"])
                    ])
                ]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.player.selfReplicatingRobotsCards.length > 0)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_4, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[1] || (_cache[1] = [
                            (0, vue_1.createTextVNode)("Self-replicating Robots cards", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    (0, vue_1.createElementVNode)("div", null, [
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.player.selfReplicatingRobotsCards, (card) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                key: card.name,
                                class: "cardbox"
                            }, [
                                (0, vue_1.createVNode)(_component_Card, { card: card }, null, 8, ["card"])
                            ]));
                        }), 128))
                    ])
                ]))
                : (0, vue_1.createCommentVNode)("", true)
        ])
    ], 512)), [
        [vue_1.vShow, _ctx.isVisible()]
    ]);
}
